import Field from '../Field';

class Text extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (force || this.validIndex[index]) {
        if (val === undefined || val === null) {
          val = '';
        }

        // TODO Array of Arrays is not handled widely
        if (!Array.isArray(val)) {
          val = String(val);
        }

        this.setValue(val, index);
        this.setDisplayValue(val, index);
      }
    });

    return this;
  }

  validate() {
    this.sanitize(true);
    super.validate();

    const { maxlengthPerLine } = this.config;
    const { maxLines } = this.config;

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      // Make sure it's a string so split doesn't fail
      if (val === undefined || val === null) {
        val = '';
      }

      // TODO Array of Arrays is not handled widely
      if (Array.isArray(val)) {
        return;
      }

      const lines = val.split('\n');

      // Check max lines
      if (maxLines && lines.length > maxLines) {
        this.invalidate(`Maximum lines (${maxLines}) exceeded.`, index);
      }

      // Check max length per line
      if (maxlengthPerLine) {
        lines.forEach((line, num) => {
          if (line.length > maxlengthPerLine) {
            this.invalidate(`Line ${num + 1} exceeds maxlength (${maxlengthPerLine}).`, index);
          }
        });
      }
    });

    return this.isValid();
  }
}

export default Text;
